/**
 * Ordenação de registros do WatermelonDB em memória.
 *
 * No 0.17.1, `Q.experimentalSortBy` É o `Q.sortBy`, e o adaptador Loki (o deste app) recusa
 * ordenação e limite (`executeQuery.js`: "sortBy not yet supported"). A query lança ao
 * executar. Por isso: buscar sem `sortBy`/`take` e ordenar aqui (G038).
 */
export function sortByRaw<T extends { _raw: Record<string, any> }>(
  rows: T[],
  column: string,
  direction: 'asc' | 'desc' = 'asc',
): T[] {
  const sign = direction === 'asc' ? 1 : -1
  return [...rows].sort(
    (a, b) => sign * ((a._raw[column] ?? 0) - (b._raw[column] ?? 0)),
  )
}
